<div class="textarea-container">
  <div class="textarea-label">
    <label *ngIf="label" [for]="id" [class.disabled]="disabled">{{ label }}</label>
  </div>
  <p *ngIf="subtitle" class="field-subtitle">{{ subtitle }}</p>
  <div class="textarea-icon-wrap">
    <div class="textarea-wrapper">
      <textarea
        [id]="id"  
        [placeholder]="placeholder || ''"
        [value]="value"
        [rows]="rows"
        [attr.aria-required]="required || null"
        [disabled]="disabled"
        [class.disabled]="disabled"
        [class.validation]="validation"
        [class.pristine]="pristine"
        [class.dirty]="dirty"
        [class.touched]="touched"
        [class.invalid]="invalid"
        [class.valid]="valid"
        (input)="valueChange($event.target.value)"
        (blur)="onBlur($event)"
      >
      </textarea>
      <div class="limits-container" *ngIf="charLimit || wordLimit">
        <span *ngIf="charLimit" class="character-limit" [class.error]="hasMaxLengthError">
          {{ 'common.field-hints.character-limit' | translate: { current: currentCharactersAmount, max: charLimit } }}
        </span>
        <span *ngIf="wordLimit" class="word-limit" [class.error]="hasMaxWordError">
          {{ 'common.field-hints.word-limit' | translate: { current: currentWordCount, max: wordLimit } }}
        </span>
      </div>
    </div>
  </div>

  <div class="footer">
    <div *ngIf="hint" class="hint">
      {{ hint }}
    </div>
    
    <div *ngIf="!disableMessages" class="messages">
      <ng-content selector="app-form-error"></ng-content>
      <ng-content selector="app-form-success"></ng-content>
    </div>
  </div>
</div>
